var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DC3545",
    d: "M20 1.87c0 1.034-.848 1.87-1.895 1.87a1.883 1.883 0 0 1-1.895-1.87C16.21.837 17.06 0 18.106 0S20 .837 20 1.87"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D2433",
    fillOpacity: 0.6,
    d: "M.634 17.73v-1.398H2.34v-7.28q0-2.013 1.25-3.563a5.6 5.6 0 0 1 3.2-1.995v-.583q0-.504.35-.853.348-.349.856-.349.509 0 .86.35.354.348.354.852v.583a5.6 5.6 0 0 1 3.203 1.995q1.252 1.55 1.252 3.563v7.28h1.706v1.399zm7.364 2.72a1.7 1.7 0 0 1-1.25-.517 1.7 1.7 0 0 1-.515-1.25h3.534q0 .735-.517 1.25a1.7 1.7 0 0 1-1.252.517M3.74 16.332h8.526v-7.28q0-1.764-1.251-3.013T7.998 4.791 4.986 6.04 3.74 9.052z"
  })));
};
export default SvgBell;